import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { DataCalendarState } from './datacalendar.state';
import { getters } from './datacalendar.getters';
import { mutations } from './datacalendar.mutations';
import { actions } from './datacalendar.actions';

VueXHelper.setStoreModule(Module.DATACALENDAR, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new DataCalendarState(),
  getters,
  mutations,
  actions,
};
